import { PropsWithChildren } from 'react';

import { FormErrorFocus } from 'components';
import { Form } from 'libs/form';
import { useTranslation } from 'libs/i18n';
import {
  OrderFormType,
  FormErrors,
  getSchema,
} from 'modules/order/common/forms/orderForm';
import { DeepPartial } from 'types/deepPartial';

import { useCreateOrderContext } from '../../providers/OrderProvider';

export interface CreateOrderFormProps {
  onSubmit: (values: OrderFormType) => void;
  formError?: FormErrors;
  initialValues?: DeepPartial<OrderFormType>;
}

export const CreateOrderForm = ({
  formError,
  initialValues,
  children,
  onSubmit,
}: PropsWithChildren<CreateOrderFormProps>) => {
  const { t } = useTranslation();

  const { orderType, disabledDates, minEndDate } = useCreateOrderContext();

  return (
    <Form
      initialErrors={formError}
      initialValues={initialValues}
      validationSchema={getSchema(t, {
        orderType,
        minEndDate,
        disabledDates,
        mode: 'create',
      })}
      onSubmit={onSubmit}
    >
      <FormErrorFocus />
      {children}
    </Form>
  );
};
